// Scroll To
//
// Same-page anchor links scroll smoothly to their target, then behave like
// the browser's own anchor jump: the URL hash updates and focus moves to the
// target, so the next Tab continues from there. Visitors who prefer reduced
// motion get the jump without the animation.

window.SiteReady(($) => {
  console.log('Init: Scroll To');

  // const $ScrollItems = $('.js-scroll_to, a[href*="#"]').not('.js-no_scroll_to, a[href*="#spu-"]');

  // $ScrollItems.on('click', onScrollTo);

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  $('body').on('click', '.js-scroll_to, a[href*="#"]:not(.js-no_scroll_to):not([href*="#spu-"])', onScrollTo);

  function onScrollTo(e) {
    const target = e.currentTarget;
    const id = target.hash;

    if (
      target.pathname !== window.location.pathname ||
      target.hostname !== window.location.hostname ||
      target.protocol !== window.location.protocol ||
      target.search !== window.location.search
    ) {
      return;
    }

    // A hash that isn't a valid selector (#/route, #!, encoded characters)
    // would make jQuery throw; leave those links to the browser
    let $to;

    try {
      $to = $(id);
    } catch (error) {
      return;
    }

    if ($to.length) {
      e.preventDefault();
      e.stopPropagation();

      // The hash a native jump would set, without its instant jump
      if (window.location.hash !== id) {
        window.history.pushState(null, '', id);
      }

      scrollToElement(id, () => {
        focusElement($to);
      });

      $(document).trigger('scroll_to');
    }
  }

  // Moves focus to the target as a native anchor jump does. Elements that
  // can't take focus get tabindex="-1" (focusable by script only); the
  // scroll has already happened, so focusing doesn't scroll again.
  function focusElement($el) {
    const el = $el[0];

    if (!el.hasAttribute('tabindex') && !$el.is('a[href], button, input, select, textarea')) {
      el.setAttribute('tabindex', '-1');
    }

    el.focus({ preventScroll: true });
  }

  function scrollToElement(id, done) {
    const $to = $(id);

    if ($to.length) {
      const offset = $to.offset();
      const margin = parseInt($to.css('scroll-margin-top'), 10) || 0;

      scrollToPosition(offset.top - margin, done);
    }
  }

  function scrollToPosition(top, done) {
    const duration = reducedMotion.matches ? 0 : 400;

    $('html, body')
      .stop()
      .animate({ scrollTop: top }, duration)
      .promise()
      .then(() => {
        if (done) {
          done();
        }
      });
  }

  function scrollDistance(distance) {
    const offset = window.scrollY;
    const duration = reducedMotion.matches ? 0 : 400;

    $('html, body').animate({ scrollTop: distance + offset }, duration);
  }

  //

  window.scrollToElement = scrollToElement;
  window.scrollToPosition = scrollToPosition;
  window.scrollDistance = scrollDistance;

});
